export const FilesSectionList = {
  flow: 'y',
  childExtends: 'FileItem',
  fontSize: 'Z2',
  flow: 'column',
  align: 'stretch',
  gap: 'X1',
  childrenAs: 'state',
  children: [
    {
      type: 'components',
      key: 'Logo',
      value: {
        Img: {},
      },
    },
    {
      type: 'components',
      key: 'Header',
      value: {
        Logo: {},
      },
    },
  ],
};